import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {videoPlay} from '../features/video-play';
import parallaxHero from '../features/parallax-hero';
import productGridReviews from '../features/product-grid';
import {quickAddProduct} from '../features/quick-add';
import {swatchGridSection} from '../features/swatch';

const sections = {};

class ImageWithText {
  constructor(section) {
    document.dispatchEvent(new CustomEvent('header:check', {bubbles: false}));
  }
}

const ImageWithTextSection = {
  onLoad() {
    sections[this.id] = new ImageWithText(this);
  },
};

register('custom-content', [slider, ImageWithTextSection, videoPlay, parallaxHero, productGridReviews, quickAddProduct, swatchGridSection]);
